<template>
  <div ref="root" class="border-y bg-deepblue text-white">
    <div class="max-w-page md:pt-24 md:pb-48 md:flex-row md:gap-0 relative flex flex-col-reverse justify-between gap-16 px-8 pt-12 mx-auto overflow-hidden">
      <div class="md:w-1/2 md:pr-24 flex items-end justify-end pb-32">
        <div class="AiCoach__stack">
          <img
            v-for="(img, i) in images"
            :key="i"
            :src="img"
            class="AiCoach__img"
            :class="{ 'is-active': i === activeImage }"
            loading="lazy"
            alt="AI Cycling coach"
          />
        </div>
      </div>
      <div class="md:w-1/2 flex">
        <div class="max-w-lg mt-32">
          <span class="opacity-60 font-mono text-sm font-medium tracking-wide uppercase">AI Cycling Coach</span>
          <h2 class="lg:text-5xl mt-3 mb-4 text-4xl font-bold leading-tight">A coach who's seen every ride you've done</h2>
          <p class="mb-5 text-xl text-white opacity-75">
            Ask FormBeat's
            <router-link :to="{ name: 'aiCyclingCoach' }" class="font-bold underline" title="AI Cycling Coach">AI Coach</router-link>
            anything - what to ride today, why a session felt flat, how to pace your next race - and it answers from your real training: your power, your
            history, how you're recovering. Not generic tips, but a read of what each ride actually meant and what to do next.
          </p>
          <p class="opacity-60 mb-6 text-lg text-white">The guidance you'd pay a coach for - for the price of an app.</p>

          <router-link :to="{ name: 'join' }" title="Create a free account">
            <AppButton class="mt-2 mb-2" primary>Try free for 30-days</AppButton>
          </router-link>
        </div>
      </div>
      <div class="lg:flex absolute bottom-0 left-0 right-0 items-start justify-center hidden gap-4 px-16 mb-24">
        <div
          class="rounded-xl inline-block px-8 py-6 mb-2 overflow-hidden text-white border border-gray-900 shadow-lg"
          style="background: #1e1e1e; color: #ccc"
        >
          <div class="data-label mb-2 text-lg font-bold">🚴 How was my last ride?</div>
          <div class="text-sm text-white opacity-75">Get a quick breakdown of your most recent activity</div>
        </div>
        <div
          class="rounded-xl inline-block px-8 py-6 mb-2 overflow-hidden text-white border border-gray-900 shadow-lg"
          style="background: #1e1e1e; color: #ccc"
        >
          <div class="data-label mb-2 text-lg font-bold">⛰️ Help me improve my climbing?</div>
          <div class="text-sm text-white opacity-75">Get personalized training recommendations</div>
        </div>
        <div
          class="rounded-xl inline-block px-8 py-6 mb-2 overflow-hidden text-white border border-gray-900 shadow-lg"
          style="background: #1e1e1e; color: #ccc"
        >
          <div class="data-label mb-2 text-lg font-bold">🎯 Where should I focus to get faster?</div>
          <div class="text-sm text-white opacity-75">Find your highest-impact training priority</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const image1 = require('images/features/mobile-ai-features.png')

export default {
  name: 'AiCyclingCoach',
  data() {
    return {
      images: [image1]
    }
  }
}
</script>
